import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import TransformationParameter from 'components/core/fields/transformation_parameters/TransformationParameter';
import DatastreamDefaultsTable from 'components/core/fields/transformation_parameters/DatastreamDefaultsTable.js';
import InfoMessages from 'components/core/help/InfoMessages';
import { colorLabelBlue } from 'styles/base';
import OverrideTable from 'components/core/fields/transformation_parameters/OverrideTable';
import RIESecondsInput from 'components/core/editable/RIESecondsInput';
import Constants from 'utils/Constants';

export default class RangeParameter extends TransformationParameter {
    static defaultProps = {
        parameterNames: ['range'],
        isOverridable: true,
        isDefaultValueVisibleInitially: true,
        isDatastreamDefaultVisibileInitially: true,
        isOverrideVisibleInitially: true,
        infoBoxText: InfoMessages.range,
    };
c
    getUnits = () => {
        let unitsLabel = 'seconds';
        if (this.props.dimensionName !== 'time') {
            const units = this.props.process.variable_retrieval.coordinate_systems[this.props.coordinateSystemName].dimensions[this.props.dimensionName].coordinate_variable_units;
            const unitsOption = Constants.getOptionById(units, Constants.COORDINATE_SYSTEM_UNITS);
            if (unitsOption !== null) {
                unitsLabel = unitsOption.value === Constants.SAME_AS_RETRIEVED_VARIABLE ? '(units same as retrieved variable)' : unitsOption.label;
            } else {
                unitsLabel = units;
            }
        }
        return unitsLabel;
    };

    renderQuestionText = () => {
        return (
            <span>When reading the input data, how far should the interpolator look for the next valid data point in the
                <span className={css`color:${colorLabelBlue}`}> {this.props.dimensionName}</span> dimension (i.e., the range)?</span>
        );
    };

    renderDefaultComponent = () => {
        const value = this.getCoordinateSystemDefaultValue();
        const unitsLabel = this.getUnits();

        return (
            <Flexbox flexDirection={'row'}>
                <span className={css`margin-right:5px;`}>Default range for all applicable datastreams:</span>
                <RIESecondsInput
                    value={value}
                    change={this.onDefaultValueChange}
                    fieldPath={this.getCoordinateSystemDefaultFieldPath()}
                    processId={this.props.process.name}
                    processErrors={this.props.processErrors}
                    isFullWidth={false}
                    formDisplay
                    isDisabled={!this.props.hasWritePermissions}
                    units={unitsLabel}
                />
                <span className={css`padding-left:5px;`}> {unitsLabel}</span>
            </Flexbox>
        );
    };

    renderDatastreamDefaultTable = () => {
        return (
            <RangeDatastreamDefaultsTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                displayInputDatastream={this.props.displayInputDatastream}
                hasWritePermissions={this.props.hasWritePermissions}
                className={css`width:100%;`}
            />
        );
    };

    renderOverrideTable = () => {
        return (
            <RangeOverrideTable
                process={this.props.process}
                processErrors={this.props.processErrors}
                parameterNames={this.props.parameterNames}
                coordinateSystemName={this.props.coordinateSystemName}
                dimensionName={this.props.dimensionName}
                hasWritePermissions={this.props.hasWritePermissions}
                units={this.getUnits()}
            />
        );
    }
}

class RangeDatastreamDefaultsTable extends DatastreamDefaultsTable {

    renderRange = (data) => {
        const value = this.getValue(data);

        return (
            <RIESecondsInput
                value={value}
                change={this.onValueChange}
                fieldPath={[]}
                onChangeData={{ name: data.name }}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                formDisplay
                isDisabled={!this.props.hasWritePermissions}
            />
        );
    };

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: 'Range',
                    props: {
                        style: {
                            whiteSpace: 'nowrap',
                        }
                    }
                },
                cell: {
                    formatters: [
                        data => { return this.renderRange(data); }
                    ]
                }
            }
        ]);
    }
}

class RangeOverrideTable extends OverrideTable {

    renderRange = (data) => {
        const value = this.getValue(data);

        //TODO: on range change need to check if need to update input dataset offsets, largest value will be used
        return (
            <RIESecondsInput
                value={value}
                change={this.onValueChange}
                fieldPath={this.getFieldPath(this.props.parameterNames[0], data)}
                onChangeData={data}
                processId={this.props.process.name}
                processErrors={this.props.processErrors}
                isFullWidth={false}
                formDisplay
                isDisabled={!this.props.hasWritePermissions}
                units={this.props.units}
            />
        );
    };

    getAdditionalColumns() {
        return ([
            {
                property: 'data',
                header: {
                    label: `Range (${this.props.units})`,
                    props: {
                        style: {
                            whiteSpace: 'nowrap',
                        }
                    }
                },
                cell: {
                    formatters: [
                        data => { return this.renderRange(data); }
                    ]
                }
            }
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/transformation_parameters/RangeParameter.js